<template>
  <div
    v-if="displayFeedbacks.length"
    class="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 border-x border-charcoal-blue"
  >
    <div
      v-for="(fb, idx) in displayFeedbacks"
      :key="fb.uuid || idx"
      class="px-4 py-8 sm:px-6 md:p-12 lg:p-16 flex flex-col justify-between min-h-[200px]"
      :class="cardClasses(idx)"
    >
      <div>
        <div class="flex gap-1 text-oxidized-copper mb-8" aria-hidden="true">
          <span
            v-for="s in 5"
            :key="s"
            class="material-icons text-2xl"
            :class="s > starCount(fb) ? 'text-charcoal-blue/40' : ''"
          >{{ s <= starCount(fb) ? 'star' : 'star_border' }}</span>
        </div>
        <p class="text-2xl font-bold italic leading-tight text-charcoal-blue mb-10">"{{ fb.text || '' }}"</p>
      </div>
      <p class="heading-utilitarian text-oxidized-copper font-extrabold text-xl">— {{ fb.name || 'Anonymous' }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  feedbacks: { type: Array, default: () => [] },
})

const displayFeedbacks = computed(() => props.feedbacks.slice(0, 3))

function cardClasses(index) {
  const base = 'border-b md:border-b-0 border-charcoal-blue'
  if (index === 0) return `${base} md:border-r border-charcoal-blue`
  if (index === 1) return `${base} md:border-r border-charcoal-blue bg-concrete-gray`
  return base
}

function starCount(fb) {
  const r = Number(fb?.rating)
  return Math.min(5, Math.max(0, Number.isNaN(r) ? 0 : Math.round(r)))
}
</script>
